<template>
    <div
        v-if="hasMessage" 
        class="text-sm mt-1"
        :class="hintType"
    >
        <slot>
            {{ hintMessage }}
        </slot>
    </div>
</template>

<script>
export default {
    props: {
        error: Boolean|String,
        warning: Boolean|String,
        info: Boolean|String,
        message: String,
    },
    computed: {
        hintType () {
            if (this.error) return 'text-red-600'
            if (this.warning) return 'text-orange-600'
            return 'text-gray-500'
        },
        hintMessage () {
            return this.message || this.error || this.warning || this.info
        },
        hasMessage () {
            return this.hintMessage || (this.$slots.default && this.$slots.default.length > 0)
        }
    }
}
</script>
